"use client";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Paper from "@mui/material/Paper";
import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";
import TextField from "@/components/site-builder/TextField";
import { useTranslation } from "@/i18n/client";
import { createBasicTextFieldObject } from "@/utils/site-builder/createBasicTextFieldObject";

export default function ThankYouMessage() {
  const { t } = useTranslation("form-elements");
  const {
    formEntity: {
      data: { successSubmitMessage = t("thank-you.message") },
    },
  } = useCustomFormContext();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 2,
        mb: 4,
      }}
    >
      <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
      <TextField
        type="title"
        field={createBasicTextFieldObject(t("thank-you.title"))}
      />
      <TextField
        type="text-regular"
        field={createBasicTextFieldObject(successSubmitMessage)}
      />
    </Paper>
  );
}
